export default "__VITE_ASSET__DX1gmQzP__"